(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-portfolio"]) return;
  try {
    
  document.querySelectorAll("[data-portfolio-page]").forEach(function(root) {
    if (root.dataset.bound === "true") return;
    root.dataset.bound = "true";

    var searchInput = root.querySelector("[data-portfolio-search]");
    var buttons = Array.prototype.slice.call(root.querySelectorAll("[data-portfolio-filter]"));
    var cards = Array.prototype.slice.call(root.querySelectorAll("[data-portfolio-card]"));
    var countNode = root.querySelector("[data-portfolio-count]");
    var emptyState = root.querySelector("[data-portfolio-empty]");
    var activeFilter = "All";
    var ignoreNextSearchSync = false;

    function findFilterValue(value) {
      if (!value) return "All";

      var normalizedValue = value.trim().toLowerCase();
      var match = buttons.find(function(button) {
        return (button.getAttribute("data-portfolio-filter") || "").trim().toLowerCase() === normalizedValue;
      });

      return match ? match.getAttribute("data-portfolio-filter") || "All" : "All";
    }

    function syncControls() {
      buttons.forEach(function(button) {
        var value = button.getAttribute("data-portfolio-filter") || "All";
        var isActive = value === activeFilter;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
      });
    }

    function updateUrl(mode) {
      if (typeof window === "undefined" || !window.history || !window.location) return;

      var url = new URL(window.location.href);
      var term = "";

      if (searchInput) {
        term = searchInput.value.trim();
      }

      if (activeFilter && activeFilter !== "All") {
        url.searchParams.set("category", activeFilter);
      } else {
        url.searchParams.delete("category");
      }

      if (term !== "") {
        url.searchParams.set("q", term);
      } else {
        url.searchParams.delete("q");
      }

      if (mode === "push") {
        window.history.pushState({}, "", url.toString());
      } else {
        window.history.replaceState({}, "", url.toString());
      }
    }

    function hydrateFromUrl() {
      if (typeof window === "undefined" || !window.location) return;

      var url = new URL(window.location.href);
      activeFilter = findFilterValue(url.searchParams.get("category"));

      if (searchInput) {
        ignoreNextSearchSync = true;
        searchInput.value = url.searchParams.get("q") || "";
      }

      syncControls();
      applyFilters(false);
    }

    function applyFilters(shouldSyncUrl) {
      var term = "";
      var visibleCount = 0;

      if (searchInput) {
        term = searchInput.value.trim().toLowerCase();
      }

      cards.forEach(function(card) {
        var category = card.getAttribute("data-category");
        var searchBlob = card.getAttribute("data-search") || "";
        var matchesCategory = activeFilter === "All" || category === activeFilter;
        var matchesSearch = term === "" || searchBlob.indexOf(term) !== -1;
        var shouldShow = matchesCategory && matchesSearch;

        card.hidden = !shouldShow;

        if (shouldShow) {
          visibleCount += 1;
        }
      });

      if (countNode) {
        countNode.textContent = visibleCount;
      }

      if (emptyState) {
        emptyState.hidden = visibleCount !== 0;
      }

      if (shouldSyncUrl !== false) {
        updateUrl("replace");
      }
    }

    buttons.forEach(function(button) {
      button.addEventListener("click", function() {
        activeFilter = button.getAttribute("data-portfolio-filter") || "All";
        syncControls();
        applyFilters(false);
        updateUrl("push");
      });
    });

    if (searchInput) {
      searchInput.addEventListener("input", function() {
        if (ignoreNextSearchSync) {
          ignoreNextSearchSync = false;
        }

        applyFilters();
      });
    }

    window.addEventListener("popstate", hydrateFromUrl);
    hydrateFromUrl();
  });

  } catch(e) { console.error(e); }
})();
})();
